//
//
//
//
//
//
//
//
//
//
var $SP = require("@/assets/sharepointplus-5.2.min.js");

import DataLoader from '@/components/DataLoader.vue';
import MainRollupTable from '@/components/MainRollupTable.vue';
import DivisionFilterButton from '@/components/DivisionFilterButton.vue';
import PanelFullLet from '@/components/PanelFullLet.vue';
import PanelDivisionFilter from '@/components/PanelDivisionFilter.vue';
export default {
  name: 'home',
  components: {
    DataLoader: DataLoader,
    PanelFullLet: PanelFullLet,
    PanelDivisionFilter: PanelDivisionFilter,
    DivisionFilterButton: DivisionFilterButton,
    MainRollupTable: MainRollupTable
  }
};